/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { MenuGroup } from '@zcode-ui/shadz-ui'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { useUserMenuContext } from '../../../module/context/UserMenuContext'
import type { ExtraNavLink, LinksSubmenuProps, MenuNavLink } from '../../../utils/getMenuNavLinks'
import { UserMenuBtnRow, UserMenuLinkRow } from '../SharedComponents'

export const UserLinksSubmenu = ({
  extraLinks,
  links,
  getLocaleLinkTitle,
  onLinkClick,
}: LinksSubmenuProps) => {
  const { dispatchTrackUserMenuClick } = useUserMenuContext()
  const { push } = useHistory()
  const onButtonClick = (link: MenuNavLink) => {
    onLinkClick?.(link.name, link.href)
    push(link.href)
  }

  const onExtraLinkClick = (link: ExtraNavLink, isButton: boolean) => {
    onLinkClick?.(link.name, link.href)
    isButton && push(link.href)
    dispatchTrackUserMenuClick(link.trackingName)
  }

  return (
    <MenuGroup>
      {links.map((link) =>
        link.is_indexed ? (
          <UserMenuLinkRow
            key={link.href}
            href={link.href}
            onClick={() => onLinkClick?.(link.name, link.href)}
          >
            {getLocaleLinkTitle(link.name)}
          </UserMenuLinkRow>
        ) : (
          <UserMenuBtnRow key={link.href} onClick={() => onButtonClick(link)}>
            {getLocaleLinkTitle(link.name)}
          </UserMenuBtnRow>
        )
      )}
      {extraLinks?.map((link) =>
        link.is_indexed ? (
          <UserMenuLinkRow
            key={link.href}
            href={link.href}
            onClick={() => onExtraLinkClick(link, false)}
          >
            {link.title}
          </UserMenuLinkRow>
        ) : (
          <UserMenuBtnRow key={link.href} onClick={() => onExtraLinkClick(link, true)}>
            {getLocaleLinkTitle(link.name)}
          </UserMenuBtnRow>
        )
      )}
    </MenuGroup>
  )
}
